<template>
  <router-view />
</template>
<style>
html,
body,
p {
  margin: 0;
  padding: 0;
}
.myPopup {
  border-radius: 16px !important;
  bottom: 16px !important;
  left: 16px !important;
  width: calc(100% - 32px) !important;
}
.van {
  font-size: 14px !important; /* 将 14px 替换为您期望的字体大小 */
}
</style>
